module.exports = __webpack_public_path__ + "/images/logo-af-otto.7bcea69.webp";